/* eslint-disable no-cond-assign */

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import { DataPoints, DataPointResponse } from '../DataPoints';
import LipperScoreCell from '../../../../views/components/cells/LipperScoreCell';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import { NotApplicableCell } from '../../../../views/components/cells';
import LipperLeaders from '@/types/lipper-leaders';

// @deprecated // TODO - REMOVE completely
export default class LipperLeaderScoresDAO extends ComparisonItemBasedProposalDAO {
  showSize: boolean | null = null;

  showBeta: boolean | null = null;

  showMER: boolean | null = null;

  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new LipperLeaderScoresDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  protected build(): void {
    let itemDAO: ComparisonItemDAO | null = null;

    const labels: string[] = [
      formatMessageWithLocale('LipperLeaderScores.ConsistentReturn', this.locale),
      formatMessageWithLocale('LipperLeaderScores.TotalReturn', this.locale),
      formatMessageWithLocale('LipperLeaderScores.Preservation', this.locale),
    ];

    for (const label of labels) {
      this.addFieldName(label, ProposalStyleClassNames.ProposalTableContent);
    }

    while ((itemDAO = this.nextItem()) !== null) {
      const lipperLeaderScores: DataPointResponse<LipperLeaders | undefined> = DataPoints.getLipperLeaderScores(itemDAO.item);

      let values: Array<number | undefined> = [undefined, undefined, undefined];

      if (lipperLeaderScores.response !== undefined) {
        this.addDisclaimerKeys(lipperLeaderScores.disclaimerKeys, itemDAO.item);

        values = [
          lipperLeaderScores.response.consistentReturn !== undefined ? lipperLeaderScores.response.consistentReturn.overall.value : undefined,
          lipperLeaderScores.response.totalReturn !== undefined ? lipperLeaderScores.response.totalReturn.overall.value : undefined,
          lipperLeaderScores.response.preservation !== undefined ? lipperLeaderScores.response.preservation.overall.value : undefined,
        ];
      }

      for (let i: number = 0; i < 3; i++) {
        const field: ProposalFieldDAO = new ProposalFieldDAO(labels[i], values[i] !== undefined ? values[i] : '', ProposalStyleClassNames.ProposalTableContent);
        field.cellType = values[i] !== undefined ? LipperScoreCell : NotApplicableCell;
        this.addFieldDAO(itemDAO, field);
      }
    }
  }
}
